"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listConversationsOutputDtoSchema = exports.listConversationsInputDtoSchema = void 0;
const zod_1 = require("zod");
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const conversation_summary_dto_js_1 = require("./conversation-summary.dto.js");
const logicOperatorSchema = zod_1.z.enum(['and', 'or']);
exports.listConversationsInputDtoSchema = zod_1.z.object({
    ownerId: conversation_summary_dto_js_1.agentChatConversationOwnerIdSchema
        .optional()
        .describe('List conversations owned by this user record instead of the caller. ' +
        'Must be an organization the caller is a member of.'),
    projectId: zod_1.z
        .string()
        .regex((0, cadstrom_shared_1.cadstromUidRegex)(cadstrom_shared_1.CadstromObjectType.Project), { message: 'projectId must be a valid project id' })
        .optional(),
    revisionId: zod_1.z
        .string()
        .regex((0, cadstrom_shared_1.cadstromUidRegex)(cadstrom_shared_1.CadstromObjectType.Build), { message: 'revisionId must be a valid build id' })
        .optional(),
    packageId: zod_1.z
        .string()
        .regex((0, cadstrom_shared_1.cadstromUidRegex)(cadstrom_shared_1.CadstromObjectType.PackageStorePackage), {
        message: 'packageId must be a valid package id',
    })
        .optional(),
    filters: cadstrom_shared_1.QueryBuilder.createColumnFilterZodSchema(cadstrom_shared_1.AgentChat.agentChatConversationFilterSchema).optional(),
    filterLogicOperator: logicOperatorSchema.optional().describe('How to combine filters. Defaults to "and".'),
    sort: cadstrom_shared_1.QueryBuilder.createSortZodSchema(cadstrom_shared_1.AgentChat.agentChatConversationFilterSchema).optional(),
    limit: zod_1.z.number().int().positive().max(100).optional().describe('Max entries per page (1–100, default 50).'),
    cursor: zod_1.z.string().optional().describe('Opaque cursor from a previous response.'),
});
exports.listConversationsOutputDtoSchema = zod_1.z.object({
    items: zod_1.z.array(conversation_summary_dto_js_1.conversationSummaryDtoSchema),
    endCursor: zod_1.z.string().nullable(),
    hasNextPage: zod_1.z.boolean(),
});
//# sourceMappingURL=list-conversations.dto.js.map